/**
 * Teacher Public 頁面入口點 - TeacherPublicPage 組件 + VisitTracker
 * Linus 原則：一頁一入口，按需載入，零混合渲染
 */

import React from 'react'
import { createRoot } from 'react-dom/client'

// 導入老師公開頁面組件
import TeacherPublicPage from 'components/TeacherPublicPage'

// 導入 VisitTracker 初始化器（此頁面需要）
import 'utils/visitTrackerInitializer'

// 只有存在容器時才掛載組件  
const container = document.getElementById('teacher-public-page')
if (container) {
  const root = createRoot(container)
  root.render(<TeacherPublicPage />)
}
